import {Component, forwardRef, Inject} from "@angular/core";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {AssetRemovalService} from "./asset-removal.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {toggleLoading} from "../misc/loading.decorator";
import {AssetGqlModel} from "./asset.gql-model";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {WorkflowService} from "../workflow/workflow.service";
import {AppSettingsService} from "../app-settings/app-settings.service";

export interface EditRemovalAssetDialogModel {
  assetId: string;
  projectId: string;
}

@Component({
  templateUrl: "./edit-removal-asset-dialog.template.pug",
})
@exposeComponentInDebugMode()
export class EditRemovalAssetDialogComponent extends DialogComponent<EditRemovalAssetDialogModel, boolean>
  implements EditRemovalAssetDialogModel {
  loading: boolean = true;
  enableAdditionalFieldsForMigration: boolean = false;
  targetSystem: string;
  assetId: string;
  projectId: string;
  result = false;
  page = "details";
  error: Error;

  asset: AssetGqlModel = new AssetGqlModel({});

  constructor(
    public dialogService: DialogService,
    private appSettingsService: AppSettingsService,
    @Inject(forwardRef(() => AssetRemovalService)) private assetRemovalService: AssetRemovalService,
    @Inject(forwardRef(() => WorkflowService)) private workflowService: WorkflowService,
  ) {
    super(dialogService);
  }

  @toggleLoading()
  @handleErrors()
  async update() {
    this.enableAdditionalFieldsForMigration = await this.appSettingsService.getFeaturePermission(
      "additionalFieldsForMigration",
      this.projectId,
    );
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    this.asset = await this.assetRemovalService.getAsset(this.assetId);
  }

  ready() {
    this.update();
  }

  @toggleLoading()
  @handleErrors()
  async save(): Promise<boolean> {
    const {updated} = await this.assetRemovalService.saveAsset(this.asset);

    this.result = updated;

    this.close();

    return this.result;
  }
}
